import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c466d990"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container my-details-container" }
const _hoisted_2 = { class: "user-data" }
const _hoisted_3 = {
  key: 0,
  class: "static-data"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { class: "my-details-container__wrapper" }
const _hoisted_6 = { class: "my-details-container__toggle" }
const _hoisted_7 = {
  key: 0,
  class: "static-data"
}
const _hoisted_8 = { class: "password-title" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "password-placeholder",
  "data-placeholder": "*********"
}, null, -1))
const _hoisted_10 = {
  key: 1,
  class: "editable-data"
}
const _hoisted_11 = {
  key: 0,
  class: "password-changed"
}
const _hoisted_12 = { class: "company-user-data" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_customer_details = _resolveComponent("customer-details")!
  const _component_box_with_title = _resolveComponent("box-with-title")!
  const _component_change_password_form = _resolveComponent("change-password-form")!
  const _component_AlternativeDelivery = _resolveComponent("AlternativeDelivery")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.customer)
        ? (_openBlock(), _createBlock(_component_box_with_title, {
            key: 0,
            title: _ctx.$t('Checkout.CustomerDetails')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                (!_ctx.isEditModeUser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_customer_details, {
                        title: _ctx.$t('CustomerDetails.Data'),
                        hideData: true,
                        source: _ctx.customer,
                        buyer: true,
                        companyType: _ctx.customer.company?.companyType
                      }, null, 8, ["title", "source", "companyType"]),
                      _hoisted_4,
                      _createVNode(_component_customer_details, {
                        title: _ctx.$t('Checkout.ShipTo'),
                        hideData: false,
                        source: _ctx.customer,
                        shipTo: true,
                        companyType: _ctx.customer.company?.companyType,
                        companyName: _ctx.customer.company?.name
                      }, null, 8, ["title", "source", "companyType", "companyName"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["title"]))
        : _createCommentVNode("", true),
      (_ctx.customer)
        ? (_openBlock(), _createBlock(_component_box_with_title, {
            key: 1,
            title: _ctx.$t('CustomerDetails.ChangePassword')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleEditModePwd && _ctx.toggleEditModePwd(...args))),
                    id: "btn-edit-pwd-data",
                    class: "my-details-container__toggle__button-edit"
                  })
                ]),
                (!_ctx.isEditModePwd)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('CustomerDetails.CurrentPassword')), 1),
                      _hoisted_9
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isEditModePwd)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_change_password_form, { "onUpdate:password": _ctx.setPwdChangedMessage }, null, 8, ["onUpdate:password"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.pwdChangedMessage)
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.pwdChangedMessage), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["title"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_12, [
      (_ctx.showPricesAsB2b)
        ? (_openBlock(), _createBlock(_component_box_with_title, {
            key: 0,
            title: _ctx.$t('Checkout.AlternativeDelivery')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AlternativeDelivery, { isCheckoutPage: false })
            ]),
            _: 1
          }, 8, ["title"]))
        : _createCommentVNode("", true)
    ])
  ]))
}